import React from "react";
import { useNavigate } from "react-router-dom";
import { useFetch } from "../lib/useApi";
import { Loader } from "./PageHead";
import { DisciplineBadge } from "./Badges";

/** SPT-PTE-2026-0046 — "Workload by technician" bar list, extracted from
 *  Dashboard.js into its own component so it can be reused verbatim (same
 *  data source, same styling) on the Job Flow Board's collapsible
 *  dashboard panel. */
export function WorkloadByTechnicianChart() {
  const navigate = useNavigate();
  const { data, loading } = useFetch("/dashboard/workload");
  const workload = data?.workload || [];
  const wlMax = Math.max(1, ...workload.map((w) => w.count));

  return (
    <div className="card pad" data-testid="workload-chart-card">
      <div className="sec-h">
        <h3>Workload by technician</h3>
        <span className="link" onClick={() => navigate("/app/active-lab")} data-testid="workload-chart-view-all">View all →</span>
      </div>
      {loading ? <Loader /> : (
        <>
          {workload.length === 0 && <div className="t-mut" style={{ fontSize: 13 }}>No active lab items assigned yet.</div>}
          {workload.map((w) => (
            <div className="bar-row" key={w.technician}>
              <div className="nm">
                <span style={{ display: "inline-flex", gap: 3, marginRight: 6, flexWrap: "wrap" }}>
                  {(w.disciplines || []).slice(0, 3).map((d) => (
                    <DisciplineBadge key={d.discipline} name={d.discipline} testid={`wl-tech-disc-${w.technician}-${d.discipline}`} />
                  ))}
                  {(w.disciplines || []).length > 3 && (
                    <span className="t-mut" style={{ fontSize: 11 }} title={(w.disciplines || []).slice(3).map((d) => `${d.discipline} (${d.count})`).join(", ")}>
                      +{w.disciplines.length - 3}
                    </span>
                  )}
                </span>
                {w.technician}
              </div>
              <div className="bar-track"><div className="bar-fill" style={{ width: `${(w.count / wlMax) * 100}%` }} /></div>
              <div className="vv">{w.count}</div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
